import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '../spinner/Spinner.jsx';

import s from './Banner.module.scss';

const renderIconOrSpinner = (banner, blue) => {
    if (!blue) return <span className={banner.icon} />;

    return <Spinner loading banner />;
};

const Banner = ({ banner, className = '' }) => {
    const visible = banner.isVisible;
    const red = banner.color === 'red';
    const green = banner.color === 'green';
    const blue = banner.color === 'blue';
    const movePoi = banner.color === 'movePoi';
    const saveMovePoi = banner.color === 'saveMovePoi';
    return (
        <div className={classNames(s.bannerMessage, { [s.visible]: visible, [s.red]: red, [s.green]: green, [s.blue]: blue, [s.movePoi]: movePoi, [s.saveMovePoi]: saveMovePoi }, [], className)}>
            {renderIconOrSpinner(banner, blue)}
            <span>{banner.message}</span>
        </div>
    );
};

Banner.propTypes = {
    banner: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default Banner;
